module.exports = __webpack_public_path__ + "img/10_77.dbc38507.png";